export const getValueFromLocalStorage = (key: string) : string | undefined => {
    try {
        const value = localStorage.getItem(key);
        return value ? value : undefined;
    } catch (error) {
        console.error(`An error occured whilst retrieving from local storage. Error details: ${error}`);
        return undefined;
    }
}

export function getJSONFromLocalStorage<T>(key: string | null): T | null {
    try {
        if(!key) return null;

        const value = localStorage.getItem(key);
        
        return value ? JSON.parse(value) as T : null;
    } catch (error) {
        console.error(`An error occured while parsing JSON from local storage ${error}`);
        return null;
    }
}